(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("es6-promise"));
	else if(typeof define === 'function' && define.amd)
		define(["es6-promise"], factory);
	else if(typeof exports === 'object')
		exports["index"] = factory(require("es6-promise"));
	else
		root["index"] = factory(root["es6-promise"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition